import PCFull from '@rebuild/materials/shared/analyst/PCFull.vue';
import MobFull from '@rebuild/materials/shared/analyst/MobFull.vue';

export const componentMap = {
	overview: PCFull,
	'mob-full': MobFull
};
